import { Button, CircularProgress, Typography } from '@material-ui/core';
import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

import useVehicles from 'core/hooks/useVehicles';
import { VehicleFiltersSchema } from 'core/schemas/vehicleFilters';
import { Thousands } from 'Elements/Formats';
import {
  Body,
  Column,
  GridTable,
  Header,
  LinkRow,
  Row as GridRow,
} from 'Elements/GridTable';

import VehicleTraffic from '../shared/VehicleTraffic';
import VehicleType from '../shared/VehicleType';

const Row = styled(GridRow)`
  grid-template-columns: 100px 100px 115px 115px minmax(150px, 1fr) 100px;
`;

const CenterColumn = styled(Column)`
  grid-column: 1 / 6;
  display: flex;
  justify-content: center;
`;

type Props = {
  params: VehicleFiltersSchema;
};

export default function VehiclesTable({ params }: Props) {
  const { vehicles, loading, hasMore, loadMore } = useVehicles(params);

  return (
    <GridTable>
      <Header>
        <Row>
          <Column>Tunniste</Column>
          <Column>Rek.no</Column>
          <Column>Tyyppi</Column>
          <Column>Kuorma</Column>
          <Column>Omistaja</Column>
          <Column>Ajettu Km</Column>
        </Row>
      </Header>

      <Body>
        {vehicles.map(vehicle => (
          <LinkRow key={vehicle.id} to={`/vehicles/${vehicle.id}`}>
            <Row>
              <Column>{vehicle.identifier}</Column>
              <Column>{vehicle.reg}</Column>
              <Column>
                <VehicleType id={vehicle.vehicle_type_id} />
              </Column>
              <Column>
                <VehicleTraffic id={vehicle.traffic_id} />
              </Column>

              <Column>
                <Link to={`/customers/${vehicle.customer_id}`}>
                  {vehicle.customer.company}
                </Link>
              </Column>

              <Column>
                <Thousands>{vehicle.kilometers}</Thousands>
              </Column>
            </Row>
          </LinkRow>
        ))}

        <Row>
          <CenterColumn>
            {loading && <CircularProgress />}

            {!loading && hasMore && (
              <Button variant="contained" color="primary" onClick={loadMore}>
                Lataa lisää
              </Button>
            )}

            {!loading && !hasMore && (
              <Typography variant="subtitle1">
                Ei enempää ajoneuvoja,{' '}
                <Link to={`/vehicles/create`}>lisää uusi</Link>
              </Typography>
            )}
          </CenterColumn>
        </Row>
      </Body>
    </GridTable>
  );
}
